// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.0
//   protoc               v3.20.3
// source: chat.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { ScenarioResultProto, ScenarioResultProto_ReferencedTreeNodes, ScenariosProcessingOutput } from "./schedule";

export const protobufPackage = "com.darwin.chat";

export interface ChatMessage {
  /** type of message */
  author?:
    | ChatMessage_Author
    | undefined;
  /** content of message */
  content?: string | undefined;
  execution_id?: string | undefined;
  tool_calls: ToolCall[];
}

export enum ChatMessage_Author {
  INVALID_AUTHOR = 0,
  SYSTEM = 1,
  HUMAN = 2,
  TOOL = 3,
  AI = 4,
  UNRECOGNIZED = -1,
}

export function chatMessage_AuthorFromJSON(object: any): ChatMessage_Author {
  switch (object) {
    case 0:
    case "INVALID_AUTHOR":
      return ChatMessage_Author.INVALID_AUTHOR;
    case 1:
    case "SYSTEM":
      return ChatMessage_Author.SYSTEM;
    case 2:
    case "HUMAN":
      return ChatMessage_Author.HUMAN;
    case 3:
    case "TOOL":
      return ChatMessage_Author.TOOL;
    case 4:
    case "AI":
      return ChatMessage_Author.AI;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ChatMessage_Author.UNRECOGNIZED;
  }
}

export function chatMessage_AuthorToJSON(object: ChatMessage_Author): string {
  switch (object) {
    case ChatMessage_Author.INVALID_AUTHOR:
      return "INVALID_AUTHOR";
    case ChatMessage_Author.SYSTEM:
      return "SYSTEM";
    case ChatMessage_Author.HUMAN:
      return "HUMAN";
    case ChatMessage_Author.TOOL:
      return "TOOL";
    case ChatMessage_Author.AI:
      return "AI";
    case ChatMessage_Author.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface ToolCall {
  call_id?: string | undefined;
  tool_name?: ToolCall_ToolType | undefined;
  tool_args?: ToolCall_ToolArgs | undefined;
}

export enum ToolCall_ToolType {
  INVALID_TOOL = 0,
  GET_TREE_SCHEMA = 1,
  GET_NODES_DATA = 2,
  GET_TREE_SUMMARY = 3,
  GET_NODES_DATA_V2 = 4,
  GET_TREE_SCHEMA_V2 = 5,
  GET_NODES_DATA_V3 = 6,
  GET_NODES_DATA_V4 = 7,
  TIGA_AS_A_TOOL = 8,
  UPDATE_CUSTOM_INSTRUCTIONS = 9,
  STRUCTURED_OUTPUT = 10,
  GET_NODES_DATA_ANALYSIS = 11,
  GET_NODES_DATA_V5 = 12,
  GET_NODES_DATA_V6 = 13,
  GET_NODES_DATA_ANALYSIS_V2 = 14,
  UNRECOGNIZED = -1,
}

export function toolCall_ToolTypeFromJSON(object: any): ToolCall_ToolType {
  switch (object) {
    case 0:
    case "INVALID_TOOL":
      return ToolCall_ToolType.INVALID_TOOL;
    case 1:
    case "GET_TREE_SCHEMA":
      return ToolCall_ToolType.GET_TREE_SCHEMA;
    case 2:
    case "GET_NODES_DATA":
      return ToolCall_ToolType.GET_NODES_DATA;
    case 3:
    case "GET_TREE_SUMMARY":
      return ToolCall_ToolType.GET_TREE_SUMMARY;
    case 4:
    case "GET_NODES_DATA_V2":
      return ToolCall_ToolType.GET_NODES_DATA_V2;
    case 5:
    case "GET_TREE_SCHEMA_V2":
      return ToolCall_ToolType.GET_TREE_SCHEMA_V2;
    case 6:
    case "GET_NODES_DATA_V3":
      return ToolCall_ToolType.GET_NODES_DATA_V3;
    case 7:
    case "GET_NODES_DATA_V4":
      return ToolCall_ToolType.GET_NODES_DATA_V4;
    case 8:
    case "TIGA_AS_A_TOOL":
      return ToolCall_ToolType.TIGA_AS_A_TOOL;
    case 9:
    case "UPDATE_CUSTOM_INSTRUCTIONS":
      return ToolCall_ToolType.UPDATE_CUSTOM_INSTRUCTIONS;
    case 10:
    case "STRUCTURED_OUTPUT":
      return ToolCall_ToolType.STRUCTURED_OUTPUT;
    case 11:
    case "GET_NODES_DATA_ANALYSIS":
      return ToolCall_ToolType.GET_NODES_DATA_ANALYSIS;
    case 12:
    case "GET_NODES_DATA_V5":
      return ToolCall_ToolType.GET_NODES_DATA_V5;
    case 13:
    case "GET_NODES_DATA_V6":
      return ToolCall_ToolType.GET_NODES_DATA_V6;
    case 14:
    case "GET_NODES_DATA_ANALYSIS_V2":
      return ToolCall_ToolType.GET_NODES_DATA_ANALYSIS_V2;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ToolCall_ToolType.UNRECOGNIZED;
  }
}

export function toolCall_ToolTypeToJSON(object: ToolCall_ToolType): string {
  switch (object) {
    case ToolCall_ToolType.INVALID_TOOL:
      return "INVALID_TOOL";
    case ToolCall_ToolType.GET_TREE_SCHEMA:
      return "GET_TREE_SCHEMA";
    case ToolCall_ToolType.GET_NODES_DATA:
      return "GET_NODES_DATA";
    case ToolCall_ToolType.GET_TREE_SUMMARY:
      return "GET_TREE_SUMMARY";
    case ToolCall_ToolType.GET_NODES_DATA_V2:
      return "GET_NODES_DATA_V2";
    case ToolCall_ToolType.GET_TREE_SCHEMA_V2:
      return "GET_TREE_SCHEMA_V2";
    case ToolCall_ToolType.GET_NODES_DATA_V3:
      return "GET_NODES_DATA_V3";
    case ToolCall_ToolType.GET_NODES_DATA_V4:
      return "GET_NODES_DATA_V4";
    case ToolCall_ToolType.TIGA_AS_A_TOOL:
      return "TIGA_AS_A_TOOL";
    case ToolCall_ToolType.UPDATE_CUSTOM_INSTRUCTIONS:
      return "UPDATE_CUSTOM_INSTRUCTIONS";
    case ToolCall_ToolType.STRUCTURED_OUTPUT:
      return "STRUCTURED_OUTPUT";
    case ToolCall_ToolType.GET_NODES_DATA_ANALYSIS:
      return "GET_NODES_DATA_ANALYSIS";
    case ToolCall_ToolType.GET_NODES_DATA_V5:
      return "GET_NODES_DATA_V5";
    case ToolCall_ToolType.GET_NODES_DATA_V6:
      return "GET_NODES_DATA_V6";
    case ToolCall_ToolType.GET_NODES_DATA_ANALYSIS_V2:
      return "GET_NODES_DATA_ANALYSIS_V2";
    case ToolCall_ToolType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface ToolCall_ToolArgs {
  /** some of the following will be set based on the type of tool */
  tree_ids: string[];
  tree_id?: string | undefined;
  node_ids: string[];
  custom_instructions?: string | undefined;
  tiga_instructions?:
    | string
    | undefined;
  /**
   * TODO: discuss whether this evaluation_functions i a json array string of the EvalFunc model
   * or just the expression? Currently it is just the expression
   *
   * List of evaluation function expressions to apply on the dataframe
   */
  evaluation_functions: string[];
  /**
   * TODO: this is under discussion since we do not know what keys
   * will be dataframes stored with (currently node index is used - planning to use
   * tool_call_id in future when the concepts of node is removed from darwin)
   *
   * tool_call_id referred by GET_NODES_DATA_ANALYSIS tool
   */
  tool_call_id?: string | undefined;
}

export interface StartChatRequest {
  user_id?: string | undefined;
  metadata_id?: string | undefined;
  transaction_id?:
    | string
    | undefined;
  /** Start new chat if true, else fetch existing chat history. */
  start_new?: boolean | undefined;
}

export interface ContinueChatRequest {
  chat_id?: string | undefined;
  user_id?: string | undefined;
  metadata_id?: string | undefined;
  transaction_id?: string | undefined;
  question?:
    | string
    | undefined;
  /** Send output in stream mode if true */
  stream?: boolean | undefined;
}

export interface ChatResponse {
  chat_id?: string | undefined;
  messages: ChatMessage[];
  scenario_result?: ScenarioResultProto | undefined;
  scenarios_output?: ScenariosProcessingOutput | undefined;
  artifacts: ChatResponse_Artifact[];
}

export interface ChatResponse_Artifact {
  artifact_type?:
    | ChatResponse_Artifact_ArtifactType
    | undefined;
  /** For REFERENCED_DATA artifact, this will contain the list of ReferencedTreeNodes */
  referenced_data: ScenarioResultProto_ReferencedTreeNodes[];
}

export enum ChatResponse_Artifact_ArtifactType {
  INVALID_ARTIFACT = 0,
  REFERENCED_DATA = 1,
  UNRECOGNIZED = -1,
}

export function chatResponse_Artifact_ArtifactTypeFromJSON(object: any): ChatResponse_Artifact_ArtifactType {
  switch (object) {
    case 0:
    case "INVALID_ARTIFACT":
      return ChatResponse_Artifact_ArtifactType.INVALID_ARTIFACT;
    case 1:
    case "REFERENCED_DATA":
      return ChatResponse_Artifact_ArtifactType.REFERENCED_DATA;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ChatResponse_Artifact_ArtifactType.UNRECOGNIZED;
  }
}

export function chatResponse_Artifact_ArtifactTypeToJSON(object: ChatResponse_Artifact_ArtifactType): string {
  switch (object) {
    case ChatResponse_Artifact_ArtifactType.INVALID_ARTIFACT:
      return "INVALID_ARTIFACT";
    case ChatResponse_Artifact_ArtifactType.REFERENCED_DATA:
      return "REFERENCED_DATA";
    case ChatResponse_Artifact_ArtifactType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface SetFeedbackRequest {
  execution_id?: string | undefined;
  feedback?: string | undefined;
}

function createBaseChatMessage(): ChatMessage {
  return { author: undefined, content: undefined, execution_id: undefined, tool_calls: [] };
}

export const ChatMessage: MessageFns<ChatMessage> = {
  encode(message: ChatMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.author !== undefined) {
      writer.uint32(8).int32(message.author);
    }
    if (message.content !== undefined) {
      writer.uint32(18).string(message.content);
    }
    if (message.execution_id !== undefined) {
      writer.uint32(26).string(message.execution_id);
    }
    for (const v of message.tool_calls) {
      ToolCall.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.author = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.content = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.execution_id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.tool_calls.push(ToolCall.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChatMessage {
    return {
      author: isSet(object.author) ? chatMessage_AuthorFromJSON(object.author) : undefined,
      content: isSet(object.content) ? globalThis.String(object.content) : undefined,
      execution_id: isSet(object.execution_id) ? globalThis.String(object.execution_id) : undefined,
      tool_calls: globalThis.Array.isArray(object?.tool_calls)
        ? object.tool_calls.map((e: any) => ToolCall.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ChatMessage): unknown {
    const obj: any = {};
    if (message.author !== undefined) {
      obj.author = chatMessage_AuthorToJSON(message.author);
    }
    if (message.content !== undefined) {
      obj.content = message.content;
    }
    if (message.execution_id !== undefined) {
      obj.execution_id = message.execution_id;
    }
    if (message.tool_calls?.length) {
      obj.tool_calls = message.tool_calls.map((e) => ToolCall.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChatMessage>, I>>(base?: I): ChatMessage {
    return ChatMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChatMessage>, I>>(object: I): ChatMessage {
    const message = createBaseChatMessage();
    message.author = object.author ?? undefined;
    message.content = object.content ?? undefined;
    message.execution_id = object.execution_id ?? undefined;
    message.tool_calls = object.tool_calls?.map((e) => ToolCall.fromPartial(e)) || [];
    return message;
  },
};

function createBaseToolCall(): ToolCall {
  return { call_id: undefined, tool_name: undefined, tool_args: undefined };
}

export const ToolCall: MessageFns<ToolCall> = {
  encode(message: ToolCall, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.call_id !== undefined) {
      writer.uint32(10).string(message.call_id);
    }
    if (message.tool_name !== undefined) {
      writer.uint32(16).int32(message.tool_name);
    }
    if (message.tool_args !== undefined) {
      ToolCall_ToolArgs.encode(message.tool_args, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ToolCall {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToolCall();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.call_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.tool_name = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tool_args = ToolCall_ToolArgs.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ToolCall {
    return {
      call_id: isSet(object.call_id) ? globalThis.String(object.call_id) : undefined,
      tool_name: isSet(object.tool_name) ? toolCall_ToolTypeFromJSON(object.tool_name) : undefined,
      tool_args: isSet(object.tool_args) ? ToolCall_ToolArgs.fromJSON(object.tool_args) : undefined,
    };
  },

  toJSON(message: ToolCall): unknown {
    const obj: any = {};
    if (message.call_id !== undefined) {
      obj.call_id = message.call_id;
    }
    if (message.tool_name !== undefined) {
      obj.tool_name = toolCall_ToolTypeToJSON(message.tool_name);
    }
    if (message.tool_args !== undefined) {
      obj.tool_args = ToolCall_ToolArgs.toJSON(message.tool_args);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ToolCall>, I>>(base?: I): ToolCall {
    return ToolCall.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ToolCall>, I>>(object: I): ToolCall {
    const message = createBaseToolCall();
    message.call_id = object.call_id ?? undefined;
    message.tool_name = object.tool_name ?? undefined;
    message.tool_args = (object.tool_args !== undefined && object.tool_args !== null)
      ? ToolCall_ToolArgs.fromPartial(object.tool_args)
      : undefined;
    return message;
  },
};

function createBaseToolCall_ToolArgs(): ToolCall_ToolArgs {
  return {
    tree_ids: [],
    tree_id: undefined,
    node_ids: [],
    custom_instructions: undefined,
    tiga_instructions: undefined,
    evaluation_functions: [],
    tool_call_id: undefined,
  };
}

export const ToolCall_ToolArgs: MessageFns<ToolCall_ToolArgs> = {
  encode(message: ToolCall_ToolArgs, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tree_ids) {
      writer.uint32(10).string(v!);
    }
    if (message.tree_id !== undefined) {
      writer.uint32(18).string(message.tree_id);
    }
    for (const v of message.node_ids) {
      writer.uint32(26).string(v!);
    }
    if (message.custom_instructions !== undefined) {
      writer.uint32(34).string(message.custom_instructions);
    }
    if (message.tiga_instructions !== undefined) {
      writer.uint32(42).string(message.tiga_instructions);
    }
    for (const v of message.evaluation_functions) {
      writer.uint32(50).string(v!);
    }
    if (message.tool_call_id !== undefined) {
      writer.uint32(58).string(message.tool_call_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ToolCall_ToolArgs {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToolCall_ToolArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tree_ids.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tree_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.node_ids.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.custom_instructions = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.tiga_instructions = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.evaluation_functions.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.tool_call_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ToolCall_ToolArgs {
    return {
      tree_ids: globalThis.Array.isArray(object?.tree_ids) ? object.tree_ids.map((e: any) => globalThis.String(e)) : [],
      tree_id: isSet(object.tree_id) ? globalThis.String(object.tree_id) : undefined,
      node_ids: globalThis.Array.isArray(object?.node_ids) ? object.node_ids.map((e: any) => globalThis.String(e)) : [],
      custom_instructions: isSet(object.custom_instructions)
        ? globalThis.String(object.custom_instructions)
        : undefined,
      tiga_instructions: isSet(object.tiga_instructions) ? globalThis.String(object.tiga_instructions) : undefined,
      evaluation_functions: globalThis.Array.isArray(object?.evaluation_functions)
        ? object.evaluation_functions.map((e: any) => globalThis.String(e))
        : [],
      tool_call_id: isSet(object.tool_call_id) ? globalThis.String(object.tool_call_id) : undefined,
    };
  },

  toJSON(message: ToolCall_ToolArgs): unknown {
    const obj: any = {};
    if (message.tree_ids?.length) {
      obj.tree_ids = message.tree_ids;
    }
    if (message.tree_id !== undefined) {
      obj.tree_id = message.tree_id;
    }
    if (message.node_ids?.length) {
      obj.node_ids = message.node_ids;
    }
    if (message.custom_instructions !== undefined) {
      obj.custom_instructions = message.custom_instructions;
    }
    if (message.tiga_instructions !== undefined) {
      obj.tiga_instructions = message.tiga_instructions;
    }
    if (message.evaluation_functions?.length) {
      obj.evaluation_functions = message.evaluation_functions;
    }
    if (message.tool_call_id !== undefined) {
      obj.tool_call_id = message.tool_call_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ToolCall_ToolArgs>, I>>(base?: I): ToolCall_ToolArgs {
    return ToolCall_ToolArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ToolCall_ToolArgs>, I>>(object: I): ToolCall_ToolArgs {
    const message = createBaseToolCall_ToolArgs();
    message.tree_ids = object.tree_ids?.map((e) => e) || [];
    message.tree_id = object.tree_id ?? undefined;
    message.node_ids = object.node_ids?.map((e) => e) || [];
    message.custom_instructions = object.custom_instructions ?? undefined;
    message.tiga_instructions = object.tiga_instructions ?? undefined;
    message.evaluation_functions = object.evaluation_functions?.map((e) => e) || [];
    message.tool_call_id = object.tool_call_id ?? undefined;
    return message;
  },
};

function createBaseStartChatRequest(): StartChatRequest {
  return { user_id: undefined, metadata_id: undefined, transaction_id: undefined, start_new: undefined };
}

export const StartChatRequest: MessageFns<StartChatRequest> = {
  encode(message: StartChatRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.user_id !== undefined) {
      writer.uint32(10).string(message.user_id);
    }
    if (message.metadata_id !== undefined) {
      writer.uint32(18).string(message.metadata_id);
    }
    if (message.transaction_id !== undefined) {
      writer.uint32(26).string(message.transaction_id);
    }
    if (message.start_new !== undefined) {
      writer.uint32(32).bool(message.start_new);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartChatRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartChatRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.user_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.metadata_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.transaction_id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.start_new = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartChatRequest {
    return {
      user_id: isSet(object.user_id) ? globalThis.String(object.user_id) : undefined,
      metadata_id: isSet(object.metadata_id) ? globalThis.String(object.metadata_id) : undefined,
      transaction_id: isSet(object.transaction_id) ? globalThis.String(object.transaction_id) : undefined,
      start_new: isSet(object.start_new) ? globalThis.Boolean(object.start_new) : undefined,
    };
  },

  toJSON(message: StartChatRequest): unknown {
    const obj: any = {};
    if (message.user_id !== undefined) {
      obj.user_id = message.user_id;
    }
    if (message.metadata_id !== undefined) {
      obj.metadata_id = message.metadata_id;
    }
    if (message.transaction_id !== undefined) {
      obj.transaction_id = message.transaction_id;
    }
    if (message.start_new !== undefined) {
      obj.start_new = message.start_new;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StartChatRequest>, I>>(base?: I): StartChatRequest {
    return StartChatRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StartChatRequest>, I>>(object: I): StartChatRequest {
    const message = createBaseStartChatRequest();
    message.user_id = object.user_id ?? undefined;
    message.metadata_id = object.metadata_id ?? undefined;
    message.transaction_id = object.transaction_id ?? undefined;
    message.start_new = object.start_new ?? undefined;
    return message;
  },
};

function createBaseContinueChatRequest(): ContinueChatRequest {
  return {
    chat_id: undefined,
    user_id: undefined,
    metadata_id: undefined,
    transaction_id: undefined,
    question: undefined,
    stream: undefined,
  };
}

export const ContinueChatRequest: MessageFns<ContinueChatRequest> = {
  encode(message: ContinueChatRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chat_id !== undefined) {
      writer.uint32(10).string(message.chat_id);
    }
    if (message.user_id !== undefined) {
      writer.uint32(18).string(message.user_id);
    }
    if (message.metadata_id !== undefined) {
      writer.uint32(26).string(message.metadata_id);
    }
    if (message.transaction_id !== undefined) {
      writer.uint32(34).string(message.transaction_id);
    }
    if (message.question !== undefined) {
      writer.uint32(42).string(message.question);
    }
    if (message.stream !== undefined) {
      writer.uint32(48).bool(message.stream);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ContinueChatRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseContinueChatRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chat_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.user_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.metadata_id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.transaction_id = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.question = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.stream = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ContinueChatRequest {
    return {
      chat_id: isSet(object.chat_id) ? globalThis.String(object.chat_id) : undefined,
      user_id: isSet(object.user_id) ? globalThis.String(object.user_id) : undefined,
      metadata_id: isSet(object.metadata_id) ? globalThis.String(object.metadata_id) : undefined,
      transaction_id: isSet(object.transaction_id) ? globalThis.String(object.transaction_id) : undefined,
      question: isSet(object.question) ? globalThis.String(object.question) : undefined,
      stream: isSet(object.stream) ? globalThis.Boolean(object.stream) : undefined,
    };
  },

  toJSON(message: ContinueChatRequest): unknown {
    const obj: any = {};
    if (message.chat_id !== undefined) {
      obj.chat_id = message.chat_id;
    }
    if (message.user_id !== undefined) {
      obj.user_id = message.user_id;
    }
    if (message.metadata_id !== undefined) {
      obj.metadata_id = message.metadata_id;
    }
    if (message.transaction_id !== undefined) {
      obj.transaction_id = message.transaction_id;
    }
    if (message.question !== undefined) {
      obj.question = message.question;
    }
    if (message.stream !== undefined) {
      obj.stream = message.stream;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ContinueChatRequest>, I>>(base?: I): ContinueChatRequest {
    return ContinueChatRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ContinueChatRequest>, I>>(object: I): ContinueChatRequest {
    const message = createBaseContinueChatRequest();
    message.chat_id = object.chat_id ?? undefined;
    message.user_id = object.user_id ?? undefined;
    message.metadata_id = object.metadata_id ?? undefined;
    message.transaction_id = object.transaction_id ?? undefined;
    message.question = object.question ?? undefined;
    message.stream = object.stream ?? undefined;
    return message;
  },
};

function createBaseChatResponse(): ChatResponse {
  return { chat_id: undefined, messages: [], scenario_result: undefined, scenarios_output: undefined, artifacts: [] };
}

export const ChatResponse: MessageFns<ChatResponse> = {
  encode(message: ChatResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chat_id !== undefined) {
      writer.uint32(10).string(message.chat_id);
    }
    for (const v of message.messages) {
      ChatMessage.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.scenario_result !== undefined) {
      ScenarioResultProto.encode(message.scenario_result, writer.uint32(26).fork()).join();
    }
    if (message.scenarios_output !== undefined) {
      ScenariosProcessingOutput.encode(message.scenarios_output, writer.uint32(34).fork()).join();
    }
    for (const v of message.artifacts) {
      ChatResponse_Artifact.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chat_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.messages.push(ChatMessage.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.scenario_result = ScenarioResultProto.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.scenarios_output = ScenariosProcessingOutput.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.artifacts.push(ChatResponse_Artifact.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChatResponse {
    return {
      chat_id: isSet(object.chat_id) ? globalThis.String(object.chat_id) : undefined,
      messages: globalThis.Array.isArray(object?.messages)
        ? object.messages.map((e: any) => ChatMessage.fromJSON(e))
        : [],
      scenario_result: isSet(object.scenario_result) ? ScenarioResultProto.fromJSON(object.scenario_result) : undefined,
      scenarios_output: isSet(object.scenarios_output)
        ? ScenariosProcessingOutput.fromJSON(object.scenarios_output)
        : undefined,
      artifacts: globalThis.Array.isArray(object?.artifacts)
        ? object.artifacts.map((e: any) => ChatResponse_Artifact.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ChatResponse): unknown {
    const obj: any = {};
    if (message.chat_id !== undefined) {
      obj.chat_id = message.chat_id;
    }
    if (message.messages?.length) {
      obj.messages = message.messages.map((e) => ChatMessage.toJSON(e));
    }
    if (message.scenario_result !== undefined) {
      obj.scenario_result = ScenarioResultProto.toJSON(message.scenario_result);
    }
    if (message.scenarios_output !== undefined) {
      obj.scenarios_output = ScenariosProcessingOutput.toJSON(message.scenarios_output);
    }
    if (message.artifacts?.length) {
      obj.artifacts = message.artifacts.map((e) => ChatResponse_Artifact.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChatResponse>, I>>(base?: I): ChatResponse {
    return ChatResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChatResponse>, I>>(object: I): ChatResponse {
    const message = createBaseChatResponse();
    message.chat_id = object.chat_id ?? undefined;
    message.messages = object.messages?.map((e) => ChatMessage.fromPartial(e)) || [];
    message.scenario_result = (object.scenario_result !== undefined && object.scenario_result !== null)
      ? ScenarioResultProto.fromPartial(object.scenario_result)
      : undefined;
    message.scenarios_output = (object.scenarios_output !== undefined && object.scenarios_output !== null)
      ? ScenariosProcessingOutput.fromPartial(object.scenarios_output)
      : undefined;
    message.artifacts = object.artifacts?.map((e) => ChatResponse_Artifact.fromPartial(e)) || [];
    return message;
  },
};

function createBaseChatResponse_Artifact(): ChatResponse_Artifact {
  return { artifact_type: undefined, referenced_data: [] };
}

export const ChatResponse_Artifact: MessageFns<ChatResponse_Artifact> = {
  encode(message: ChatResponse_Artifact, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.artifact_type !== undefined) {
      writer.uint32(8).int32(message.artifact_type);
    }
    for (const v of message.referenced_data) {
      ScenarioResultProto_ReferencedTreeNodes.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatResponse_Artifact {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatResponse_Artifact();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.artifact_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.referenced_data.push(ScenarioResultProto_ReferencedTreeNodes.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChatResponse_Artifact {
    return {
      artifact_type: isSet(object.artifact_type)
        ? chatResponse_Artifact_ArtifactTypeFromJSON(object.artifact_type)
        : undefined,
      referenced_data: globalThis.Array.isArray(object?.referenced_data)
        ? object.referenced_data.map((e: any) => ScenarioResultProto_ReferencedTreeNodes.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ChatResponse_Artifact): unknown {
    const obj: any = {};
    if (message.artifact_type !== undefined) {
      obj.artifact_type = chatResponse_Artifact_ArtifactTypeToJSON(message.artifact_type);
    }
    if (message.referenced_data?.length) {
      obj.referenced_data = message.referenced_data.map((e) => ScenarioResultProto_ReferencedTreeNodes.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChatResponse_Artifact>, I>>(base?: I): ChatResponse_Artifact {
    return ChatResponse_Artifact.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChatResponse_Artifact>, I>>(object: I): ChatResponse_Artifact {
    const message = createBaseChatResponse_Artifact();
    message.artifact_type = object.artifact_type ?? undefined;
    message.referenced_data =
      object.referenced_data?.map((e) => ScenarioResultProto_ReferencedTreeNodes.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSetFeedbackRequest(): SetFeedbackRequest {
  return { execution_id: undefined, feedback: undefined };
}

export const SetFeedbackRequest: MessageFns<SetFeedbackRequest> = {
  encode(message: SetFeedbackRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.execution_id !== undefined) {
      writer.uint32(10).string(message.execution_id);
    }
    if (message.feedback !== undefined) {
      writer.uint32(18).string(message.feedback);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetFeedbackRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetFeedbackRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.execution_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.feedback = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetFeedbackRequest {
    return {
      execution_id: isSet(object.execution_id) ? globalThis.String(object.execution_id) : undefined,
      feedback: isSet(object.feedback) ? globalThis.String(object.feedback) : undefined,
    };
  },

  toJSON(message: SetFeedbackRequest): unknown {
    const obj: any = {};
    if (message.execution_id !== undefined) {
      obj.execution_id = message.execution_id;
    }
    if (message.feedback !== undefined) {
      obj.feedback = message.feedback;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetFeedbackRequest>, I>>(base?: I): SetFeedbackRequest {
    return SetFeedbackRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetFeedbackRequest>, I>>(object: I): SetFeedbackRequest {
    const message = createBaseSetFeedbackRequest();
    message.execution_id = object.execution_id ?? undefined;
    message.feedback = object.feedback ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
